var m = require('mithril');

var layout = require('../layout/layout');
var modalForm = require('../layout/components/modalForm');
var networkOverviewPage = require('../network/components/networkOverviewPage');
var hostPage = require('../network/components/hostPage');
var resourcePage = require('../network/components/resourcePage');

var restHttpModel = require('./models/restHttp');
var restResourceModel = require('./models/restResource');

var routes = {
  '/rest': {
    view: function() {
      return m(layout, m(networkOverviewPage, { form: restHttpModel, activeTab:'Networks'}));
    },
  },
  '/resthttp': {
    view: function() {
      return m(layout, m(networkOverviewPage, { form: restHttpModel, activeTab:'Networks' }));
    },
  },
  '/resthttp/:id': {
    view: function() {
      return m(layout, m(hostPage, { recordModel: restHttpModel, form: modalForm(restResourceModel), activeTab:'Networks' }));
    }, 
  },
  '/restresource/:id': {
    view: function() {
      return m(layout, m(resourcePage, { recordModel: modalForm(restResourceModel), activeTab: 'Networks' }));
    }, 
  }
};

module.exports = routes;
